var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-circle",class:_vm.additionalClasses,style:(_vm.styleObj)})
}
var staticRenderFns = []

export { render, staticRenderFns }